import * as React from "react";
import {
  withStyles,
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";
import {
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import i18n from "i18n";

const theme = createMuiTheme({
  palette: {
    primary: {
      light: "#9AAF00",
      main: "#9AAF00",
      dark: "#9AAF00",
      contrastText: "#9AAF00",
    },
    secondary: {
      light: "#ececec",
      main: "#838383",
      dark: "#393939",
      contrastText: "#646464",
    },
  },
  typography: { useNextVariants: true },
  overrides: {
    MuiDialog: {
      paper: {
        borderRadius: "6px",
        backgroundColor: "#FFF",
      },
    },
  },
});
const styles = (theme) => ({});

const Alert = (props) => {
  const { classes, startOpen, unlinkComposition, lineSelected, close } = props;

  const handleClose = () => {
    close();
  };

  const handleConfirm = async () => {
    unlinkComposition(lineSelected).then(() => handleClose());
  };

  return (
    <MuiThemeProvider theme={theme}>
      <Dialog
        open={startOpen}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">
          {i18n.unlinkCompositionDialog.title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <Typography color="textPrimary" variant="body1">
              {i18n.unlinkCompositionDialog.body}
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            {i18n.unlinkCompositionDialog.cancel}
          </Button>
          <Button onClick={handleConfirm} color="primary">
            {i18n.unlinkCompositionDialog.confirm}
          </Button>
        </DialogActions>
      </Dialog>
    </MuiThemeProvider>
  );
};

export default withStyles(styles as any)(Alert);



// WEBPACK FOOTER //
// ./src/modules/WBS/components/layouts/Alert.tsx